// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tgpp-not-found-container {
  width: 100vw;
  height: 100vh;
  opacity: 0.95;
  margin-top: -15px;
}
.tgpp-not-found-container .tgpp-not-found-inner-container {
  margin: 0 0 75px 0;
}
.tgpp-not-found-container .tgpp-not-found-title {
  font-size: 30px;
}
.tgpp-not-found-container .tgpp-not-found-sub-title {
  height: 40px;
  width: 3670px;
  color: rgba(14, 19, 25, 0.8);
  margin: 0 0 20px 0;
  font-size: 20px;
}
.tgpp-not-found-container .tgpp-not-found-oval {
  height: 80px;
  width: 80px;
  background-color: #FFFFFF;
  box-shadow: 2px 2px 5px 0px rgba(14, 19, 25, 0.4), 2px 2px 4px 0 rgba(14, 19, 25, 0.08);
  border-radius: 50%;
}
.tgpp-not-found-container .tgpp-not-found-oval-inside {
  height: 32px;
  width: 32px;
  background-color: #CC0000;
  border-radius: 50%;
}
.tgpp-not-found-container .tgpp-not-found-fill-1 {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/component/not-found/not-found.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,iBAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,YAAA;EACA,aAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAIE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,uFAAA;EACA,kBAAA;AAFJ;AAKE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAHJ;AAME;EACE,YAAA;AAJJ","sourcesContent":[".tgpp-not-found-container {\n  width: 100vw;\n  height: 100vh;\n  opacity: 0.95;\n  margin-top: -15px;\n\n  .tgpp-not-found-inner-container {\n    margin: 0 0 75px 0;\n  }\n\n  .tgpp-not-found-title {\n    font-size: 30px;\n  }\n\n  .tgpp-not-found-sub-title {\n    height: 40px;\n    width: 3670px;\n    color: rgba(14, 19, 25, 0.8);\n    margin: 0 0 20px 0;\n    font-size: 20px;\n  }\n\n  .tgpp-not-found-oval {\n    height: 80px;\n    width: 80px;\n    background-color: #FFFFFF;\n    box-shadow: 2px 2px 5px 0px rgba(14, 19, 25, 0.4), 2px 2px 4px 0 rgba(14, 19, 25, 0.08);\n    border-radius: 50%;\n  }\n\n  .tgpp-not-found-oval-inside {\n    height: 32px;\n    width: 32px;\n    background-color: #CC0000;\n    border-radius: 50%;\n  }\n\n  .tgpp-not-found-fill-1 {\n    color: white;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
